import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet } from 'react-native';

import { IconLink, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const UpsellCloseIcon = (props: UpsellCloseIconProps) => {
  const { onPress, disabled } = props;
  const { formatMessage } = useIntl();

  return (
    <IconLink
      name="IconClose"
      width={40}
      height={40}
      palette="muted"
      color={theme.colors.BLACK}
      onPress={onPress}
      disabled={disabled}
      accessibilityLabel={formatMessage(messages.closeButtonA11yLabel)}
      style={styles.closeButton}
    />
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  closeButtonA11yLabel: {
    defaultMessage: 'Close dialog',
    description: 'Menu | Upsell | Close icon button',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  closeButton: {},
});

// ─────────────────────────────────────────────────────────────────────────────

type UpsellCloseIconProps = {
  onPress: () => void;
  disabled?: boolean;
};
